import { Menu } from 'lucide-react';

import OrganizerContainer from 'modules/organizer/ui/components/organizer-container';
import SubscriptionExpiryNotifier from 'modules/organizer/ui/components/subscription-expiry-notifier';
import JivoChatLoader from 'modules/support-chat/components/jivo-chat-loader';
import React from 'react';
import { Outlet } from 'react-router-dom';
import UDMenu from 'modules/app-shell/ui/components/menu';
import { useMainLayout } from './context';
import * as S from './styles';

type Props = {
  children?: React.ReactNode;
  headerContent?: React.ReactNode;
  contentClassName?: string;
};

const UDMainLayout = React.memo((props: Props) => {
  const { headerContent, contentClassName } = useMainLayout();
  const [isMobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const openMenu = React.useCallback(() => setMobileMenuOpen(true), []);
  const closeMenu = React.useCallback(() => setMobileMenuOpen(false), []);

  React.useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeMenu();
    };
    if (isMobileMenuOpen) {
      document.addEventListener('keydown', onKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen, closeMenu]);

  return (
    <OrganizerContainer>
      {(isLoading, info) => (
        <S.Container>
          <S.Menu>
            <UDMenu isOrganizerLoading={isLoading} organizerInfo={info} />
          </S.Menu>
          <S.Header>
            <S.BurgerButton aria-label="Открыть меню" onClick={openMenu} className="mr-2">
              <Menu />
            </S.BurgerButton>
            {headerContent || props.headerContent}
          </S.Header>

          {isMobileMenuOpen && (
            <>
              <S.MobileMenuOverlay onClick={closeMenu} />
              <S.MobileMenuPanel>
                <UDMenu isOrganizerLoading={isLoading} organizerInfo={info} />
              </S.MobileMenuPanel>
            </>
          )}

          <S.MainBlockWrapper>
            <S.Content className={contentClassName || props.contentClassName}>
              <JivoChatLoader />
              <SubscriptionExpiryNotifier />
              <Outlet />
            </S.Content>
          </S.MainBlockWrapper>
        </S.Container>
      )}
    </OrganizerContainer>
  );
});

export default UDMainLayout;
